<header>
  <app-head (newItemEvent)="addItem($event)" [titleModule]="'Generate Reports'"></app-head>
</header>
<div class="row m-0">

  <!-- start sidebar  -->
  <app-sidebar class="col-lg-2" [showSide]="showSide" [titlepage]="'Reports'"></app-sidebar>
  <!-- end sidebar  -->

  <!-- start content page  -->
  <main class="p-4 col-lg-10 ">

      <div class="fw-inquiries d-flex justify-content-between" style="color: #6c6a6a;">
          <p class="fw-bold ms-1" style="color: #6c6a6a;">Generate Reports Module</p>
          <div class="d-flex justify-content-lg-between  ">

          </div>


      </div>
      <p-toast></p-toast>

      <!--General info-->
      <!--start General info form-->
      <div class="card mt-2">

          <div class="row paroductApartment  px-1">
              <div class="bg-white p-12 xpp12">



                  <div class="row" style="margin-bottom: 20px;">
                      <div class="mb-3 col-12 col-md-4">

                          <label for="exampleInputPricepermonth" class="form-label gray  ">Start Date</label>
                          <p-calendar [(ngModel)]="rpt_start_date" [showTime]="false" styleClass="w-100" dateFormat="yy-mm-dd" [showSeconds]="true"></p-calendar>

                      </div>
                      <div class="mb-3 col-12 col-md-4">

                        <label for="exampleInputPricepermonth" class="form-label gray  ">End Date</label>
                        <p-calendar [(ngModel)]="rpt_end_date" [showTime]="false" styleClass="w-100" dateFormat="yy-mm-dd" [showSeconds]="true"></p-calendar>

                      </div>
                      <div class="mb-3 col-12 col-md-4">

                        <label for="exampleInputPricepermonth" class="form-label gray  ">Report Type</label>
                        <select class="s-cont form-select form-select" [(ngModel)]="selected_type" name="selected_type" id="selected_type">
                          <option  value="" disabled> Select Report Type  </option>

                        <option *ngFor="let type of rpt_type" [value]="type.name"> {{type.name}} </option>


                    </select>
                      </div>

                  </div>

                  <div class="div-4">
                      <div class="div-5 text-center align-items-center d-flex justify-content-center">

                          <div class="div-6">
                              <!-- <button class="auto-layout-button"><div class="label-2">Cancel</div></button> -->


                              <button (click)="GenerateButton()" class="rounded-2 text-white rounded-2 border-0 py-2 px-4" style="background-color: #1f4068 !important">
                              Download Report
                </button>
                              <!-- <button class="label-wrapper"><div class="label-3">save</div>
                  </button> -->
                          </div>
                      </div>
                  </div>
              </div>


          </div>
      </div>
  </main>
  <!-- end content page  -->
</div>
